import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import React, { createContext, useEffect, useState, useContext, useRef } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from '../../custom-components/QMentisBreadCrumb';
import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material'
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestCaseUI from '../../output-components/test-automation/TestCaseImported';
import InputForm from '../../output-components/test-automation/PageSource';
import PageClass from '../../output-components/test-automation/PageClass';
import Locators from '../../output-components/test-automation/Locators';
import TestMethods from '../../output-components/test-automation/TestMethods';
import StepDefinition from '../../output-components/test-automation/StepDefinition';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { TestngJavaPageclassWithToolCalling, TestngJavaTestMethodsWithToolCalling, TestngJavaWithToolCalling } from '../../../services/webServices';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import UploadBox from '../input-pages/UploadBox';
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import TestEnvironmentForm from '../../output-components/test-automation/TestEnvironment';
import MessagePopup from '../../popup-components/MessagePopup';
import JSZip from "jszip";
import { saveAs } from "file-saver";

const JavaTestngNewProjectOutputPage = () => {
    const location = useLocation();
      const navigate = useNavigate();
      // const [testCaseDetails, setTestCaseDetails] = useState([]);
      // const [pageSources, setPageSources] = useState("");
      // const [locators, setLocators] = useState({});
      // const [pageClasses, setPageClasses] = useState("");
      // const [stepDefinitions, setstepDefinitions] = useState("");
      // const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
    
      const [testEnvironment, setTestEnviorment] = useState({});
      const [testCase, setTestCase] = useState({});
      const [pageSource, setPageSource] = useState('');
      const [locator, setLocator] = useState('');
      const [pageClass, setPageClass] = useState('');
      const { setLoadingState } = useContext(LoadingModalContext);
      const [downloadOpen, setDownloadOpen] = useState(false);
      const [confirmed, setConfirmed] = useState(false);
      const [popupOpen, setPopupOpen] = useState(false);
      const [popupMessage, setPopupMessage] = useState("");
      const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
      const [framework, setFramework] = useState('');
      const [projectType, setProjectType] = useState('');
      const [zipBlob, setZipBlob] = useState(null);
      const [testMethods, setTestMethods] = useState([]);
      const [showInputForm, setShowInputForm] = useState(false);
      const scrollContainerRef = useRef(null);
      const testMethodsRef = useRef(null);


      useEffect(() => {
        // console.log("🔍 Received location.state:", location.state);
        console.log(location.state, "javaseleniumtestng");
        // console.log("🔹 Initializing component with framework:", location.state?.frameworkType);
        // console.log("🔹 location.state keys:", Object.keys(location.state || {}));
        setProjectType(location.state?.projectType || "");
        setTestEnviorment(location.state?.testenvironmentdata || {});
        setTestCase(location.state?.testCaseData || {});
        setPageSource(location.state?.pageSource || "");
        console.log("Locator before getPrimaryFields:", locator);
        setLocator(location.state?.generatedLocators || {});
        setPageClass(location.state?.generatedPageclassData || "");
        setFramework(location.state?.framework || "")
      }, [location.state?.testCaseData, location.state?.testenvironmentdata, location.state?.pageSource, location.state?.generatedLocators, location.state?.generatedPageclassData, location.state?.framework,
      location.state?.projectType
      ]);
    
    useEffect(() => {
      if (testMethodsRef.current) {
        testMethodsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, [testMethods]);

      const breadCrumbs = [
    {
        title: "Set Test Environment",
        status: Object.entries(testEnvironment).length !== 0 || confirmed ? "Completed" : "In Progress",
    },
    {
        title: "Test Case Details",
        status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testEnvironment).length !== 0 && Object.entries(testCase).length === 0
            ? "In Progress"
            : "Not Started",
    },
    {
        title: "Introduce SUT",
        status: !!pageSource && pageSource !== ""
        ? "Completed"
        : Object.entries(testCase).length > 0 
            ? "In Progress"
            : "Not Started",
    },
    {
        title: "Generate Locators",
        status: Object.keys(locator).length > 0
        ? "Completed"
        : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },
    {
        title: "Page Class",
        status: !!pageClass && pageClass !== ""
        ? "Completed"
        : Object.keys(locator).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
        title: "Test Methods",
        status: testMethods.length > 0
        ? "Completed"
        : !!pageClass && pageClass !== ""
            ? "In Progress"
            : "Not Started",
    },
    ];

    const handleIntroduceSUT = () => {
      setShowInputForm(true);
    }

    const handleGenerateTestCases = async () => {
        let fake;
    
        const startProgress = (setProgress) => {
          let progress = 0;
          let stop = false;
          let finalMessageShown = false;
    
          const interval = setInterval(() => {
            if (stop) return;
    
            progress += 1.8;
            if (progress >= 97 && !finalMessageShown) {
              finalMessageShown = true;
              setLoadingState((prev) => ({
                ...prev,
                message: "Almost done! Fetching your output",
              }));
            }
    
            if (progress >= 97) progress = 97;
    
            setProgress((prev) => ({
              ...prev,
              progress: Math.max(prev.progress, Math.floor(progress)),
            }));
          }, 200);
    
          return {
            stop: () => {
              stop = true;
              clearInterval(interval);
            },
            completeTo100: async () => {
              stop = true;
              clearInterval(interval);
    
              // Rush to 100%
              setProgress((prev) => ({
                ...prev,
                progress: 100,
              }));
              await new Promise((res) => setTimeout(res, 500));
            },
          };
        };
    
        const finishTo100AndClose = async () => {
          await fake.completeTo100();
          setLoadingState({ open: false, message: "", progress: null });
        };
        // Initial message
        setLoadingState({
          open: true,
          message: "Generating Testng Testcases",
          progress: 0,
        });
    
        fake = startProgress(setLoadingState);
        try {
          
          await finishTo100AndClose();

        }
        catch (error) {
          const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
          setPopupMessage(errorMsg);
          setPopupOpen(true);
          if (error.response?.data?.Error === "Your session has expired.") {
            setSessionExpiredValue(true);
          }
          setLoadingState({ open: false, message: "", progress: null });
        }
        finally {
          // setLoading(false);
          setLoadingState({ open: false, message: "", progress: null });
        }
    };

    const handleGenerateTestMethods = async () => {
        let fake;

        const startProgress = (setProgress) => {
            let progress = 0;
            let stop = false;
            let finalMessageShown = false;

            const interval = setInterval(() => {
            if (stop) return;

            progress += 1.8;
            if (progress >= 97 && !finalMessageShown) {
                finalMessageShown = true;
                setLoadingState((prev) => ({
                ...prev,
                message: "Almost done! Fetching your test methods",
                }));
            }

            if (progress >= 97) progress = 97;

            setProgress((prev) => ({
                ...prev,
                progress: Math.max(prev.progress, Math.floor(progress)),
            }));
            }, 200);

            return {
            stop: () => {
                stop = true;
                clearInterval(interval);
            },
            completeTo100: async () => {
                stop = true;
                clearInterval(interval);
                setProgress((prev) => ({ ...prev, progress: 100 }));
                await new Promise((res) => setTimeout(res, 500));
            },
            };
        };

        const finishTo100AndClose = async () => {
            await fake.completeTo100();
            setLoadingState({ open: false, message: "", progress: null });
        };

        setLoadingState({
            open: true,
            message: "Generating Test Methods",
            progress: 0,
        });

        fake = startProgress(setLoadingState);

        try {
            const requestData = {
            pageClassData: pageClass,
            locators: locator,
            testCaseData: testCase,
            environmentData: testEnvironment,
            };
              const response = await TestngJavaTestMethodsWithToolCalling(requestData);

            const generatedTestMethods = response.data.map(cls => ({
                className: cls.class_name,
                code: cls.code_lines.join("\n")
            }));
            console.log("Generated Test Methods:", generatedTestMethods);

            setTestMethods(generatedTestMethods); 
        } catch (error) {
            const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
            setPopupMessage(errorMsg);
            setPopupOpen(true);
            if (error.response?.data?.Error === "Your session has expired.") {
            setSessionExpiredValue(true);
            }
            setLoadingState({ open: false, message: "", progress: null });
        } finally {
            setLoadingState({ open: false, message: "", progress: null });
        }
        };
    
    const handleProjectGeneration = async () => {
      let fake;

      const startProgress = (setProgress) => {
        let progress = 0;
        let stop = false;
        let finalMessageShown = false;

        const interval = setInterval(() => {
          if (stop) return;

          progress += 1;
          if (progress >= 97 && !finalMessageShown) {
            finalMessageShown = true;
            setLoadingState((prev) => ({
              ...prev,
              message: "Almost done! Fetching your output",
            }));
          }
          if (progress >= 97) progress = 97;

          setProgress((prev) => ({
            ...prev,
            progress: Math.max(prev.progress, Math.floor(progress)),
          }));
        }, 200);

        return {
          stop: () => {
            stop = true;
            clearInterval(interval);
          },
          completeTo100: async () => {
            stop = true;
            clearInterval(interval);

            setProgress((prev) => ({ ...prev, progress: 100 }));
            await new Promise((res) => setTimeout(res, 500));
          },
        };
      };

      setLoadingState({
        open: true,
        message: "Generating TestNG Java Project",
        progress: 0,
      });

      fake = startProgress(setLoadingState);

      try {
        const projectFilesResponse = await TestngJavaWithToolCalling({
          pageClassData: pageClass,
          testEnvironmentData: testEnvironment,
          testCaseData: testCase,
          testmethodsData: testMethods,
        });

        const zip = new JSZip();

        const safeAdd = (folder, path, content) => {
          try {
            if (content) folder.file(path, content);
          } catch (e) {
            console.warn("Skipping invalid file:", path);
          }
        };

        const data = projectFilesResponse?.data || {};

        // 1. Add project metadata
        // zip.file("pom.xml", projectFilesResponse.data["ProjectMetadata"]["pom.xml"]);
        // zip.file("testng.xml", projectFilesResponse.data["ProjectMetadata"]["testng.xml"]);
        // zip.file("README.md", projectFilesResponse.data["Documentation"]["README.md"]);
        // zip.file(
        //   "src/main/resources/testdata.json",
        //   projectFilesResponse.data["Test Data"]
        // );

        const configPropertiesContent = `url=${data?.testEnvironmentData?.url || "https://default-url.com"}`;
        safeAdd(zip, "src/test/resources/config.properties", configPropertiesContent);

        if (data.testCaseData) {
          const testDataJson = JSON.stringify(data.testCaseData, null, 2);
          safeAdd(zip, "src/main/resources/testdata.json", testDataJson);
        }

        // Add testdata.properties 
        if (data.testCaseData) {
          const props = Object.entries(data.testCaseData)
            .map(([key, value]) => `${key}=${value}`)
            .join("\n");
          safeAdd(zip, "src/test/resources/testdata.properties", props);
        }
        
        if (data.ProjectMetadata) {
          safeAdd(zip, "pom.xml", data.ProjectMetadata["pom.xml"]);
          safeAdd(zip, "testng.xml", data.ProjectMetadata["testng.xml"]);
        }

        // 2️⃣ Documentation
        if (data.Documentation?.["README.md"]) {
          safeAdd(zip, "README.md", data.Documentation["README.md"]);
        }

        // 3️⃣ Test Data
        // if (data["Test Data"]) {
        //   safeAdd(zip, "src/main/resources/testdata.json", data["Test Data"]);
        // }
        // 2. Add Page Classes
        // const pageObjectsFolder = zip.folder("src/main/java/pageobjects");
        // projectFilesResponse.data.PageClasses.forEach((page) => {
        //   pageObjectsFolder.file(
        //     `${page.class_name}.java`,
        //     page.code_lines.join("\n")
        //   );
        // });

        // // 3. Add Test Classes
        // const testClassesFolder = zip.folder("src/test/java/tests");
        // projectFilesResponse.data.TestClasses.forEach((test) => {
        //   testClassesFolder.file(
        //     `${test.class_name}.java`,
        //     test.code_lines.join("\n")
        //   );
        // });

        if (Array.isArray(data.pageClassData)) {
          const pageFolder = zip.folder("src/main/java/pageobjects");
          data.pageClassData.forEach((page) => {
            safeAdd(
              pageFolder,
              `${page.className || "UnknownPage"}.java`,
              (page.code_lines || []).join("\n")
            );
          });
        }

        // 5️⃣ Test Classes
        if (Array.isArray(data.testmethodsData)) {
          const testFolder = zip.folder("src/test/java/tests");
          data.testmethodsData.forEach((test) => {
            safeAdd(
              testFolder,
              `${test.className || "UnknownTest"}.java`,
              (test.code_lines || []).join("\n")
            );
          });
        }

        const commonutils = `
        package utils;

import java.util.List;
import java.util.Random;

public class CommonUtils {
    private static final Random random = new Random();

    // Generates a random string of given length using letters
    public static String generateRandomString(int length) {
        String chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        StringBuilder sb = new StringBuilder(length);
        for (int i = 0; i < length; i++) {
            sb.append(chars.charAt(random.nextInt(chars.length())));
        }
        return sb.toString();
    }

    // Generates a random number of given count (count = number of digits)
    public static int generateRandomNumber(int count) {
        if (count <= 0) return 0;
        int min = (int) Math.pow(10, count - 1);
        int max = (int) Math.pow(10, count) - 1;
        return randomNumber(min, max);
    }

    // Returns a random value from a list (generic)
    public static <T> T getRandomValueFromList(List<T> list) {
        if (list == null || list.isEmpty()) return null;
        return list.get(random.nextInt(list.size()));
    }

    // Generates a random string of given length using letters and numbers
    public static String generateRandomAlphanumericString(int length) {
        String chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        StringBuilder sb = new StringBuilder(length);
        for (int i = 0; i < length; i++) {
            sb.append(chars.charAt(random.nextInt(chars.length())));
        }
        return sb.toString();
    }

    // Generates a random numeric string of given length
    public static String generateRandomNumeric(int length) {
        String digits = "0123456789";
        StringBuilder sb = new StringBuilder(length);
        for (int i = 0; i < length; i++) {
            sb.append(digits.charAt(random.nextInt(digits.length())));
        }
        return sb.toString();
    }

    // Returns a random element from a list (generic)
    public static <T> T getRandomElement(List<T> list) {
        return getRandomValueFromList(list);
    }

    // Returns a random number between min and max (inclusive)
    public static int randomNumber(int min, int max) {
        if (min > max) throw new IllegalArgumentException("min > max");
        return min + random.nextInt((max - min) + 1);
    }
}
`
        zip.file("src/main/java/utils/CommonUtils.java", commonutils);

        const  configreaderutils = `
        package utils;

import java.io.FileInputStream;
import java.io.IOException;
import java.util.Properties;

public class ConfigReader {
    private static Properties properties = new Properties();

    static {
        try (FileInputStream fis = new FileInputStream("src/test/resources/config.properties")) {
            properties.load(fis);
        } catch (IOException e) {
            e.printStackTrace();
            throw new RuntimeException("Failed to load config.properties file.");
        }
    }

    public static String getUrl() {
        return properties.getProperty("url");
    }

    // Add other getters if more properties added
}
`
        zip.file("src/main/java/utils/ConfigReader.java",configreaderutils);

        const dateutils = `
        package utils;

import org.apache.logging.log4j.LogManager;
import org.apache.logging.log4j.Logger;

import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.util.concurrent.TimeUnit;

public class DateUtils {
    private static final Logger logger = LogManager.getLogger(DateUtils.class);

    public static Date getCurrentDate() {
        logger.debug("Getting current date");
        Date date = new Date();
        logger.debug("Current date: " + date.toString());
        return date;
    }

    public static long getCurrentTimestamp() {
        logger.debug("Getting current timestamp");
        long timestamp = System.currentTimeMillis();
        logger.debug("Current timestamp: " + timestamp);
        return timestamp;
    }

    public static String formatDate(Date date, String format) {
        if (format == null || format.isEmpty()) format = "yyyy-MM-dd";
        logger.debug("Formatting date: " + date + " with format: " + format);

        SimpleDateFormat sdf = new SimpleDateFormat(convertFormat(format));
        String formattedDate = sdf.format(date);

        logger.debug("Formatted date: " + formattedDate);
        return formattedDate;
    }

    // Converts custom format syntax to Java SimpleDateFormat
    private static String convertFormat(String format) {
        return format.replace("YYYY", "yyyy")
                .replace("DD", "dd")
                .replace("HH", "HH")
                .replace("mm", "mm")
                .replace("ss", "ss")
                .replace("SSS", "SSS");
    }

    public static Date parseDate(String dateString, String format) {
        logger.debug("Parsing date from string: " + dateString);
        try {
            Date date;
            if (format != null && !format.isEmpty()) {
                SimpleDateFormat sdf = new SimpleDateFormat(convertFormat(format));
                date = sdf.parse(dateString);
            } else {
                date = new SimpleDateFormat("yyyy-MM-dd").parse(dateString);
            }

            logger.debug("Parsed date: " + date);
            return date;
        } catch (ParseException e) {
            logger.error("Date parsing failed: " + e.getMessage());
            throw new IllegalArgumentException("Invalid date string: " + dateString, e);
        }
    }

    public static Date addDays(Date date, int days) {
        logger.debug("Adding " + days + " days to date: " + date);
        Date result = new Date(date.getTime() + TimeUnit.DAYS.toMillis(days));
        logger.debug("New date: " + result);
        return result;
    }

    public static Date addHours(Date date, int hours) {
        logger.debug("Adding " + hours + " hours to date: " + date);
        Date result = new Date(date.getTime() + TimeUnit.HOURS.toMillis(hours));
        logger.debug("New date: " + result);
        return result;
    }

    public static Date subtractDays(Date date, int days) {
        logger.debug("Subtracting " + days + " days from date: " + date);
        Date result = new Date(date.getTime() - TimeUnit.DAYS.toMillis(days));
        logger.debug("New date: " + result);
        return result;
    }

    public static long getDaysDifference(Date date1, Date date2) {
        logger.debug("Getting days difference between " + date1 + " and " + date2);
        long timeDiff = Math.abs(date2.getTime() - date1.getTime());
        long daysDiff = TimeUnit.MILLISECONDS.toDays(timeDiff);
        logger.debug("Days difference: " + daysDiff);
        return daysDiff;
    }

    public static String generateTimestampForFileName() {
        logger.debug("Generating timestamp for file name");
        String timestamp = formatDate(new Date(), "yyyy-MM-dd_HH-mm-ss-SSS");
        logger.info("Timestamp for file name: " + timestamp);
        return timestamp;
    }
}
`
        zip.file("src/main/java/utils/DateUtils.java",dateutils);

        const drivermanagerutils = `
        package utils;

import io.github.bonigarcia.wdm.WebDriverManager;
import org.openqa.selenium.WebDriver;
import org.openqa.selenium.chrome.ChromeDriver;

public class DriverManager {
    private static ThreadLocal<WebDriver> driver = new ThreadLocal<>();

    public static WebDriver getDriver() {
        if (driver.get() == null) {
            setDriver();
        }
        return driver.get();
    }

    private static void setDriver() {
        WebDriverManager.chromedriver().setup();
        WebDriver localDriver = new ChromeDriver();
        localDriver.manage().window().maximize();
        driver.set(localDriver);
    }

    public static void quitDriver() {
        if (driver.get() != null) {
            driver.get().quit();
            driver.remove();
        }
    }
}
`
        zip.file("src/main/java/utils/DriverManager.java",drivermanagerutils);

        const fileutils = `
        package utils;

import org.apache.logging.log4j.LogManager;
import org.apache.logging.log4j.Logger;

import java.io.IOException;
import java.nio.charset.StandardCharsets;
import java.nio.file.*;
import java.util.List;
import java.util.stream.Collectors;
import java.util.stream.Stream;

public class FileUtils {

    private static final Logger logger = LogManager.getLogger(FileUtils.class);

    public static boolean fileExists(String filePath) {
        logger.debug("Checking if file exists: {}", filePath);
        Path path = Paths.get(filePath);
        boolean exists = Files.exists(path) && Files.isRegularFile(path);
        logger.debug("File exists: {}", exists);
        return exists;
    }

    public static boolean directoryExists(String dirPath) {
        logger.debug("Checking if directory exists: {}", dirPath);
        Path path = Paths.get(dirPath);
        boolean exists = Files.exists(path) && Files.isDirectory(path);
        logger.debug("Directory exists: {}", exists);
        return exists;
    }

    public static void createDirectory(String dirPath) {
        logger.debug("Creating directory: {}", dirPath);
        try {
            Files.createDirectories(Paths.get(dirPath));
            logger.info("Directory created: {}", dirPath);
        } catch (IOException e) {
            logger.error("Failed to create directory: {}", dirPath, e);
            throw new RuntimeException(e);
        }
    }

    public static String readFile(String filePath) {
        logger.debug("Reading file: {}", filePath);
        Path path = Paths.get(filePath);
        try {
            byte[] bytes = Files.readAllBytes(path);
            String content = new String(bytes, StandardCharsets.UTF_8);
            logger.info("File read successfully: {}", filePath);
            return content;
        } catch (IOException e) {
            logger.error("Failed to read file: {}", filePath, e);
            throw new RuntimeException(e);
        }
    }

    public static void writeFile(String filePath, String content) {
        logger.debug("Writing file: {}", filePath);
        try {
            createDirectory(getDirectoryName(filePath));
            Path path = Paths.get(filePath);
            Files.write(path, content.getBytes(StandardCharsets.UTF_8),
                    StandardOpenOption.CREATE, StandardOpenOption.TRUNCATE_EXISTING);
            logger.info("File written successfully: {}", filePath);
        } catch (IOException e) {
            logger.error("Failed to write file: {}", filePath, e);
            throw new RuntimeException(e);
        }
    }

    public static void appendFile(String filePath, String content) {
        logger.debug("Appending to file: {}", filePath);
        try {
            createDirectory(getDirectoryName(filePath));
            Path path = Paths.get(filePath);
            Files.write(path, content.getBytes(StandardCharsets.UTF_8),
                    StandardOpenOption.CREATE, StandardOpenOption.APPEND);
            logger.info("Content appended to file: {}", filePath);
        } catch (IOException e) {
            logger.error("Failed to append to file: {}", filePath, e);
            throw new RuntimeException(e);
        }
    }

    public static void deleteFile(String filePath) {
        logger.debug("Deleting file: {}", filePath);
        try {
            Files.deleteIfExists(Paths.get(filePath));
            logger.info("File deleted: {}", filePath);
        } catch (IOException e) {
            logger.error("Failed to delete file: {}", filePath, e);
            throw new RuntimeException(e);
        }
    }

    public static void deleteDirectory(String dirPath, boolean recursive) {
        logger.debug("Deleting directory: {}", dirPath);
        Path dir = Paths.get(dirPath);
        try {
            if (recursive && Files.exists(dir)) {
                List<Path> pathsToDelete;
                try (Stream<Path> walk = Files.walk(dir)) {
                    pathsToDelete = walk.sorted((a, b) -> b.compareTo(a))
                            .collect(Collectors.toList());
                }
                for (Path path : pathsToDelete) {
                    try {
                        Files.deleteIfExists(path);
                    } catch (IOException e) {
                        logger.error("Failed to delete: {}", path, e);
                    }
                }
            } else {
                Files.deleteIfExists(dir);
            }
            logger.info("Directory deleted: {}", dirPath);
        } catch (IOException e) {
            logger.error("Failed to delete directory: {}", dirPath, e);
            throw new RuntimeException(e);
        }
    }

    public static void copyFile(String sourcePath, String destinationPath) {
        logger.debug("Copying file: {} -> {}", sourcePath, destinationPath);
        try {
            createDirectory(getDirectoryName(destinationPath));
            Files.copy(Paths.get(sourcePath), Paths.get(destinationPath), StandardCopyOption.REPLACE_EXISTING);
            logger.info("File copied: {} -> {}", sourcePath, destinationPath);
        } catch (IOException e) {
            logger.error("Failed to copy file: {} -> {}", sourcePath, destinationPath, e);
            throw new RuntimeException(e);
        }
    }

    public static void moveFile(String sourcePath, String destinationPath) {
        logger.debug("Moving file: {} -> {}", sourcePath, destinationPath);
        try {
            createDirectory(getDirectoryName(destinationPath));
            Files.move(Paths.get(sourcePath), Paths.get(destinationPath), StandardCopyOption.REPLACE_EXISTING);
            logger.info("File moved: {} -> {}", sourcePath, destinationPath);
        } catch (IOException e) {
            logger.error("Failed to move file: {} -> {}", sourcePath, destinationPath, e);
            throw new RuntimeException(e);
        }
    }

    public static String getFileName(String filePath) {
        logger.debug("Getting file name: {}", filePath);
        String name = Paths.get(filePath).getFileName().toString();
        logger.info("File name: {}", name);
        return name;
    }

    public static String getDirectoryName(String filePath) {
        logger.debug("Getting directory name: {}", filePath);
        Path parent = Paths.get(filePath).getParent();
        String dirName = (parent != null) ? parent.toString() : "";
        logger.info("Directory name: {}", dirName);
        return dirName;
    }
}
`
        zip.file("src/main/java/utils/FileUtils.java",fileutils);

        const loggerhelperutils = `
        package utils;

import org.apache.logging.log4j.LogManager;
import org.apache.logging.log4j.Logger;

public class LoggerHelper {

    // Obtain a logger for the calling class
    public static Logger getLogger(Class<?> clazz) {
        return LogManager.getLogger(clazz);
    }
}

`
        zip.file("src/main/java/utils/LoggerHelper.java",loggerhelperutils);

        const testdatareaderutils = `
        package utils;

import java.io.FileInputStream;
import java.io.IOException;
import java.util.Properties;

public class TestDataReader {
    private Properties properties = new Properties();

    public TestDataReader() {
        try (FileInputStream fis = new FileInputStream("src/test/resources/testdata.properties")) {
            properties.load(fis);
        } catch (IOException e) {
            e.printStackTrace();
            throw new RuntimeException("Failed to load testdata.properties");
        }
    }

    public String getSearchQuery() {
        return properties.getProperty("searchQuery");
    }

    // Add more getter methods for other test data keys
}
`
        zip.file("src/main/java/utils/TestDataReader.java",testdatareaderutils);

        const testdatautils = `
        package utils;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.core.type.TypeReference;
import org.apache.logging.log4j.LogManager;
import org.apache.logging.log4j.Logger;

import java.io.File;
import java.util.Map;
import java.util.Set;

public class TestDataUtils {
    private static final Logger logger = LogManager.getLogger(TestDataUtils.class);
    private static final String TEST_DATA_PATH = "src/test/resources/test-data.json";
    private static Map<String, Object> testDataJson;

    // Static block to load test data once at startup
    static {
        try {
            ObjectMapper mapper = new ObjectMapper();
            testDataJson = mapper.readValue(new File(TEST_DATA_PATH), new TypeReference<Map<String, Object>>() {});
            logger.info("Test data loaded successfully from " + TEST_DATA_PATH);
        } catch (Exception e) {
            logger.error("Failed to load test data from " + TEST_DATA_PATH, e);
            throw new RuntimeException(e);
        }
    }

    public static Object getTestData(String key) {
        logger.debug("Getting test data for key: " + key);

        if (!testDataJson.containsKey(key)) {
            logger.error("Test data not found for key: " + key);
            throw new IllegalArgumentException("Test data not found for key: " + key);
        }

        Object data = testDataJson.get(key);
        logger.debug("Successfully retrieved test data for key: " + key);
        return data;
    }

    public static Map<String, Object> getAllTestData() {
        logger.debug("Getting all test data");
        return testDataJson;
    }

    public static boolean hasTestDataKey(String key) {
        logger.debug("Checking if test data key exists: " + key);
        boolean exists = testDataJson.containsKey(key);
        logger.debug("Test data key '" + key + "' exists: " + exists);
        return exists;
    }

    public static Set<String> getAvailableKeys() {
        logger.debug("Getting available test data keys");
        Set<String> keys = testDataJson.keySet();
        logger.debug("Available test data keys: " + keys);
        return keys;
    }
}
`
        zip.file("src/main/java/utils/TestDataUtils.java",testdatautils);

        const webdriverfactory = `
        package utils;
import io.github.bonigarcia.wdm.WebDriverManager;
import org.openqa.selenium.WebDriver;
import org.openqa.selenium.chrome.ChromeDriver;

public class WebDriverFactory {
    public static WebDriver createDriver() {
        WebDriverManager.chromedriver().setup();
        return new ChromeDriver();
    }
}
`
        zip.file("src/main/java/utils/WebDriverFactory.java",webdriverfactory);

        // 5. Add Config
        // const configFolder = zip.folder("src/main/java/config");
        // Object.entries(projectFilesResponse.data.Configuration).forEach(
        //   ([filename, content]) => {
        //     configFolder.file(`${filename}.java`, content);
        //   }
        // );

        // if (data.Configuration && typeof data.Configuration === "object") {
        //   const configFolder = zip.folder("src/test/java/config");
        //   Object.entries(data.Configuration).forEach(([filename, content]) => {
        //     safeAdd(configFolder, `${filename}.java`, content);
        //   });
        // }

        if (data.Configuration && typeof data.Configuration === "object") {
          Object.entries(data.Configuration).forEach(([filepath, content]) => {
            const parts = filepath.split("/");
            const fileName = parts.pop(); 
            let currentFolder = zip;

            parts.forEach(part => {
              currentFolder = currentFolder.folder(part);
            });

            safeAdd(currentFolder, fileName, content);
          });
        }

        // 6. Generate and save ZIP
        zip.generateAsync({ type: "blob" }).then((content) => {
          setZipBlob(content);
          saveAs(content, "Selenium_TestNG_Project.zip");
        });
      } catch (error) {
        const errorMsg =
          error?.response?.data?.Error || "An error occurred. Please try again.";
        setPopupMessage(errorMsg);
        setPopupOpen(true);
      } finally {
        await fake.completeTo100();
        setLoadingState({ open: false, message: "", progress: null });
      }
    };


    function transformLocatorForPrimary(locator) {
        const transformed = {};
        for (const key in locator) {
            if (Array.isArray(locator[key])) {
            transformed[key] = {
                primary: locator[key].filter((l) => l.includes("xpath")),
                secondary: locator[key].filter((l) => !l.includes("xpath")),
            };
            } else if (typeof locator[key] === "object" && locator[key] !== null) {
            transformed[key] = {
                primary: locator[key].xpath ? [locator[key].xpath] : [],
                secondary: [
                ...(locator[key].tagName ? [locator[key].tagName] : []),
                ...(locator[key].cssSelector ? [locator[key].cssSelector] : []),
                ],
            };
            } else {
            transformed[key] = { primary: [], secondary: [] };
            }
        }
        return transformed;
    }
     
      

    const handlePageClass = async () => {

        const primaryFieldsObject = getPrimaryFields(locator);
        console.log("PrimaryFieldsObject:", primaryFieldsObject);

        let fake;
        const startProgress = (setProgress) => {
            let progress = 0;
            let stop = false;
            let finalMessageShown = false;
            const interval = setInterval(() => {
            if (stop) return;
            progress += 1.8;
            if (progress >= 97 && !finalMessageShown) {
                finalMessageShown = true;
                setLoadingState((prev) => ({
                ...prev,
                message: "Almost done! Fetching your output",
                }));
            }
            if (progress >= 97) progress = 97;
            setProgress((prev) => ({
                ...prev,
                progress: Math.max(prev.progress, Math.floor(progress)),
            }));
            }, 200);
            return {
            stop: () => {
                stop = true;
                clearInterval(interval);
            },
            completeTo100: async () => {
                stop = true;
                clearInterval(interval);

                // Rush to 100%
                setProgress((prev) => ({
                ...prev,
                progress: 100,
                }));
                await new Promise((res) => setTimeout(res, 500));
            },
            };
        };

        const finishTo100AndClose = async () => {
            await fake.completeTo100();
            setLoadingState({ open: false, message: "", progress: null });
        };

        // Initial message
        setLoadingState({
            open: true,
            message: "Generating Page Classes",
            progress: 0,
        });

        fake = startProgress(setLoadingState);

        try {
            const requestData = {
            locators: primaryFieldsObject,
            testCaseData: testCase,
            };

            const generatedPageClassGenerated = await TestngJavaPageclassWithToolCalling(
            requestData,
            location.state?.framework
            );

            const generatedPageClass = generatedPageClassGenerated.data;
            navigate(location.pathname, {
            state: { ...location.state, generatedPageclassData: generatedPageClass },
            replace: true,
            });
        } catch (error) {
            const errorMsg =
            error?.response?.data?.Error || "An error occurred. Please try again.";
            setPopupMessage(errorMsg);
            setPopupOpen(true);
            if (error.response?.data?.Error === "Your session has expired.") {
            setSessionExpiredValue(true);
            }
            setLoadingState({ open: false, message: "", progress: null });
        } finally {
            setLoadingState({ open: false, message: "", progress: null });
        }
        };


    const handleGitHubProject = async () => {
      console.log("Navigating to GitHub with zipBlob:", zipBlob);

      if (!zipBlob) {
        console.error("ZIP file not generated yet.");
        return;
      }
      navigate(`/dashboard/test-automation/newproject-gitcredentials`, {
        state: {
          framework: framework,
          projectType: projectType,
          zipFile: zipBlob,
        },
      });
    };
    
    const projectGenerationButton = [
    
        {
          label: "Generate Maven Project",
          variant: "contained",
          onClick: handleProjectGeneration,
          startIcon: <GenerateButton />,
          sx: { float: "right"},
        },
        {
          label: "Push to GitHub",
          variant: "contained",
          startIcon: <GenerateButton />,
          sx: { marginRight: 1, whiteSpace: "nowrap" },
          onClick: handleGitHubProject,
          disabled: !zipBlob, 
        },
    ]
    
    function getPrimaryFields(response) {
        const primaryFields = {};
        for (const key in response) {
            const item = response[key];
            if (item?.primary && Array.isArray(item.primary) && item.primary.length > 0) {
            if (item.primary[0].startsWith("class")) {
                primaryFields[key] = item.secondary || [];
            } else {
                primaryFields[key] = item.primary;
            }
            }
        }
        return primaryFields;
    }

    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    const testcaseNextButton = {
        label: "Introduce SUT",
        onClick: ()=>{
          handleGenerateTestCases();
          handleIntroduceSUT();
        },
        startIcon: <GenerateButton />,
        variant: "contained",
        sx: { float: "right" },
    };

  const javaSeliniumDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none" },
  };

  const locatorsNextButton = {
    label: "Generate Page Class",
    variant: "contained",
    onClick: handlePageClass,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }

  const testMethodsNextButton = {
    label: "Generate Test Methods",
    variant: "contained",
    onClick: handleGenerateTestMethods,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
    };

  const handleCloseDownload = () => {
      setDownloadOpen(false);
    }
    const formatTestPlan = (testPlanData) => {
      const formattedTestPlan = {};
      Object.entries(testPlanData).map(([key, value]) => {
        if (Array.isArray(value)) {
          return (formattedTestPlan[key] = flattenArray(value));
        }
        if (!!value && typeof value === "object") {
          return (formattedTestPlan[key] = flattenObject(value));
        }
        return (formattedTestPlan[key] = value);
      });
      return formattedTestPlan;
    };

    return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >

      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", 
            width: "100%",
            zIndex: 1000, 
            bgcolor: "white", 
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", 
          }}
        >


          <QMentisBreadCrumb breadCrumbs={breadCrumbs} sx={{ height: "56px" }} />
        </Box>
        <Box
          ref={scrollContainerRef}
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", 
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />




            </Box>
            {/* JAVA COMPONENTS */}
            {/* {Object.entries(testEnvironment).length === 0 && ( */}
            <TestEnvironmentForm
              testEnvironmentData={testEnvironment}
              setTestEnviorment={setTestEnviorment}
              framework={location.state?.framework}
              projectType={location.state?.projectType}
              confirmed={confirmed}
              setConfirmed={setConfirmed}
            />
            {/* )} */}

            {confirmed && (
              <UploadBox
                testCaseData={testCase}
                setTestCase={setTestCase}
                testcaseNextButton={testcaseNextButton}
                javaSeliniumDownloadButton={javaSeliniumDownloadButton}
              />
            )}
            {confirmed && Object.entries(testCase).length > 0 && <TestCaseUI testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} projectType={projectType} />}
            {confirmed && Object.entries(testCase).length > 0 && showInputForm && ( <InputForm setPageSource={setPageSource} pageSource={pageSource} />)}
            {Object.entries(locator).length > 0 && <Locators locator={locator} setLocator={setLocator} locatorsNextButton={locatorsNextButton} projectType={projectType} />}
            
            {!!pageClass && pageClass !== "" && (
                <>
                    <PageClass
                    pageClass={pageClass}
                    setPageClass={setPageClass}
                    testMethodsNextButton={handleGenerateTestMethods}
                    projectType={projectType} 
                    showGenerateTestButton={true}
                    />
                </>
            )}
            {!!testMethods && testMethods.length > 0 && ( 
              <div ref={testMethodsRef}>
                <TestMethods
                    testMethods={testMethods}
                    projectType={projectType}
                    nextButton={projectGenerationButton}
                />
              </div>
            )}

            
          </Box>
        </Box>
        <Container
          sx={{
            width: "100%",
          }}
        >


          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
    </Box>
  );
}

export default JavaTestngNewProjectOutputPage;
